import { setStaffMemberCategories } from '../../../api'
import { STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY } from '../../../constants/entity'
import { EntityTabCategories } from '../../EntityTab'
import { UserEditCategoriesModal } from '../../User'

import {
  USER_PROFILE_TAB_CATEGORIES_EXTRA_LIST_PARAMS,
  USER_PROFILE_TAB_CATEGORIES_QA_NAME,
  USER_PROFILE_TAB_CATEGORIES_SCOPE_FILTER_KEY,
} from './UserProfileTabCategories.constants'

function UserProfileTabCategories({ userData, onReloadTabCounters }) {
  async function handleSaveCategories({ categoryIds }) {
    return setStaffMemberCategories({
      data: { categories: categoryIds },
      id: userData?.id,
    })
  }

  return (
    <EntityTabCategories
      EditModal={UserEditCategoriesModal}
      entity={STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY}
      extraListParams={USER_PROFILE_TAB_CATEGORIES_EXTRA_LIST_PARAMS}
      qaName={USER_PROFILE_TAB_CATEGORIES_QA_NAME}
      scopeFilterKey={USER_PROFILE_TAB_CATEGORIES_SCOPE_FILTER_KEY}
      scopeId={userData?.id}
      onReloadCounters={onReloadTabCounters}
      onSave={handleSaveCategories}
    />
  )
}

export default UserProfileTabCategories
